import { DomainBasedRequestSource } from '@common/util-models';

export function getRequestSource({
  defaultRequestSource,
  domainBasedRequestSources,
}: {
  defaultRequestSource?: string;
  domainBasedRequestSources?: DomainBasedRequestSource[];
}): string {
  const url: URL = new URL(window?.location.href);

  const domainBasedRequestSource: string | undefined =
    domainBasedRequestSources?.find((source: DomainBasedRequestSource) =>
      source.pattern.test(url.href)
    )?.requestSource;

  return domainBasedRequestSource ?? defaultRequestSource ?? '';
}
